// React

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
// Redux
import { Provider } from "react-redux";
import store from './services/store/store'

// Cookies
import { CookiesProvider } from 'react-cookie';

// Stylesheet
import './assets/css/icons.css'

// Translation Hook
import { setTranslations, setDefaultLanguage ,getLanguage } from 'react-multi-lang'
import en from './laguages/en.json'
import ar from './laguages/ar.json'
import {BrowserRouter} from 'react-router-dom'
import { createRoot } from 'react-dom/client';
// Routes
import AppRoutes from './services/routes/AppRoutes';
import './assets/css/global.css'
import SettingProvider from './services/context/setting-contentxt/setting-provider';
import './assets/scss/global1.scss'
import PermissionProvider from './services/context/permission-context/permission-provider';
import {createTheme ,ThemeProvider} from '@mui/material'
import DeleteModalProvider from './services/context/delete-modal/delete-modal-provider';
import {APIProvider} from './services/context/api-context/api-provider'
import { EllipsisLoader } from './components/Loader/Loader';
// Setting up translations
setTranslations({ en, ar })
setDefaultLanguage(localStorage.getItem("lang") ? String(localStorage.getItem("lang")) : 'en')

const root_element=document.getElementById('root')
const root =createRoot(root_element! )
 root.render   (<Provider store={store}>
        <SettingProvider>
            <CookiesProvider>
                <APIProvider>
                <PermissionProvider>
                    <DeleteModalProvider>
                <React.StrictMode>
                     <BrowserRouter>
                 
                            <AppRoutes />
                     
                 
                     </BrowserRouter>
                </React.StrictMode>
                </DeleteModalProvider>
                </PermissionProvider>
                </APIProvider>
            </CookiesProvider>
        </SettingProvider>
    </Provider>)
   
